import React from 'react';
import styled, { keyframes } from 'styled-components';

const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;

  position: fixed;
  top: calc(50% - 84px);
  left: 0px;
  right: 0px;

  z-index: 100;

  width: 164px;
  height: 168px;
  margin: 0 auto;

  border-radius: 12px;

  background-color: #000000cc;

  color: #fff;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
`;

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const SpinnerWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Loader = styled.div`
  width: 52px;
  height: 52px;
  border: 4px solid rgba(221, 221, 221, 0.1);
  border-top: 4px solid rgba(255, 255, 255, 0.8);
  border-radius: 50%;
  animation: ${spin} 1s linear infinite;
`;

function ExcelLoading() {
  return (
    <LoadingContainer>
      <SpinnerWrapper>
        <Loader />
      </SpinnerWrapper>

      <p>
        엑셀 파일을 <br />
        내려받는 중이에요
      </p>
    </LoadingContainer>
  );
}

export default ExcelLoading;
